import React from "react"
import { Route, Switch } from "react-router-dom"
import {
  indexPage,
  ukmPage,
  batchsPage,
  cameraPage,
  ordersPage,
  reportsPage,
  aggregationsPage,
  profilePage,
  employeePage,
  registrationPage,
  linesPage,
  terminalsPage,
  testingPage,
  productsPage,
  documentsPage,
} from "../config/routesInfo"
import IndexPage from "../pages/IndexPage"
import UKMPage from "../pages/UKMPage"
import BatchsPage from "../pages/BatchsPage"
import CameraPage from "../pages/CameraPage"
import OrdersPage from "../pages/OrdersPage"
import ReportsPage from "../pages/ReportsPage"
import AggregationsPage from "../pages/AggregationsPage"
import ProfilePage from "../pages/ProfilePage"
import NotFoundPage from "../pages/NotFoundPage"
import EmployeePage from "../pages/EmployeePage"
import RegistrationPage from "../pages/RegistrationPage"
import LinesPage from "../pages/LinesPage"
import TerminalsPage from "../pages/TerminalsPage"
import TestingPage from "../pages/TestingPage"
import ProductsPage from "../pages/ProductsPage"
import DocumentsPage from "../pages/DocumentsPage"

const Router = () => {
  return (
    <>
      <Switch>
        <Route exact path={`/${indexPage.path}`} component={IndexPage} />
        <Route path={`/${ukmPage.path}`} component={UKMPage} />
        <Route path={`/${batchsPage.path}`} component={BatchsPage} />
        <Route path={`/${cameraPage.path}`} component={CameraPage} />
        <Route path={`/${ordersPage.path}`} component={OrdersPage} />
        <Route path={`/${reportsPage.path}`} component={ReportsPage} />
        <Route
          path={`/${aggregationsPage.path}`}
          component={AggregationsPage}
        />
        <Route path={`/${profilePage.path}`} component={ProfilePage} />
        <Route path={`/${employeePage.path}`} component={EmployeePage} />
        <Route
          path={`/${registrationPage.path}`}
          component={RegistrationPage}
        />
        <Route path={`/${linesPage.path}`} component={LinesPage} />
        <Route path={`/${terminalsPage.path}`} component={TerminalsPage} />
        <Route path={`/${testingPage.path}`} component={TestingPage} />
        <Route path={`/${productsPage.path}`} component={ProductsPage} />
        <Route path={`/${documentsPage.path}`} component={DocumentsPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </>
  )
}

export default Router
